import "swiper/swiper-bundle.css";
import { StrictMode } from "react";
import "flatpickr/dist/flatpickr.css";
import { createRoot } from "react-dom/client";

import "./index.css";
import "./locales/i18n";
import App from "./App.tsx";
import { ThemeProvider } from "./context/ThemeContext";
import { AppWrapper } from "./components/common/PageMeta";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <AppWrapper>
        <App />
      </AppWrapper>
    </ThemeProvider>
  </StrictMode>
);
